export default {
  title: 'فرم روش ارسال',
  detail:'ایجاد و ویرایش  روش ارسال',
  nameFa : 'عنوان فارسی',
  nameEn : 'عنوان لاتین',
  shippingCost:'هزینه ی ارسال',
  status: 'وضعیت',
  statusActive: 'فعال',
  statusInActive: 'غیرفعال',
  back : 'لغو',
  success : 'موفق',
  error : 'خطا',
  save : 'ذخیره',
  loading : 'در حال بارگزاری',
  saving : 'در حال بارگزاری ...',
  placeholderNameFa:'عنوان فارسی را وارد نماید',
  placeholderNameEn:'عنوان لاتین را وارد نماید',
  placeholderShippingCost:'هزینه ی ارسال'


}
